<div class="row" *ngIf="show">
  <div class="col-12">
    <div class="alert mt-2 text-center alert-primary" role="alert">
      <span translate>TYLO_DELIVERY_TIME_PRELIMINARY</span>
    </div>
  </div>
</div>
